/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React from 'react';
import { observer } from 'mobx-react';

import { LayoutBase, ReactLayoutImplBase } from '../base/LayoutBase';
import CreateExplorationLayout from 'components/startingPoints/create/CreateExplorationLayout';	//This should be not starting points-specific

@observer
export class VisPlaceholderView extends ReactLayoutImplBase {

	constructor(props) {
		super(props);

		this.boardModel = this.props.layoutController.boardModel;

		this.services = props.services;

		this.Component = VisPlaceholder;
	}

	render() {
		return (
			<CreateExplorationLayout
				fill={true}
				services={this.props.services}
				activeDataSourceId={this.boardModel.layout.exploreVM.activeDataSourceId}
				handleShowVisTypesClick={() => this._showVisTypesDialog()}
				createVis={(visModel) => this.createVis(visModel)}
			/>
		);
	}

	_showVisTypesDialog() {
		this.layoutOwner.parentLayout.showVisTypesDialog(this.model.id);
	}

	createVis(widgetSpec) {
		this.layoutOwner.parentLayout.createVis(widgetSpec, this.model.id);
	}
}

const VisPlaceholder = class VisPlaceholder extends LayoutBase {
	constructor(props){
		super(props);
		this.Component = VisPlaceholderView;
		this.parentLayout.addChildRenderMarkup(this.id, this.getRenderMarkup());
	}

	getRenderMarkup() {
		return (
			<VisPlaceholderView layoutOwner={this} model={this.model} layoutController={this.layoutController} services={this.services}></VisPlaceholderView>
		);
	}
};


export default VisPlaceholder;



// WEBPACK FOOTER //
// ./src/js/layout/create/VisPlaceholder.js